import { app_domain } from 'app/config/constants'
import i18next from 'i18next'
import HttpBackend from 'i18next-http-backend'
import { makeAutoObservable, runInAction } from 'mobx'
import { initReactI18next } from 'react-i18next'
import { skipAsync } from 'util/async'

function getDomainLang(): string {
  if (app_domain == 'atelier') return 'en'
  if (app_domain == 'dresscode') return 'en'
  return 'ru'
}

function getForceLang(): string | undefined {
  const search = new URLSearchParams(window.location.search)
  if (search.has('en')) return 'en'
  if (search.has('ru')) return 'ru'
  return undefined
}

const bundle_lang = 'en'
const domain_lang = getDomainLang()
const force_lang = getForceLang()

class LanguageController {
  private _init = false
  private _ready = false
  private _lang = bundle_lang

  constructor() {
    makeAutoObservable(this)
  }

  get ready(): boolean {
    return this._ready
  }

  get lang(): string {
    return this._lang
  }

  set lang(custom: string | null | undefined) {
    const lang = force_lang || custom || domain_lang
    void this.changeLanguage(lang)
  }

  private readonly changeLanguage = skipAsync(async (lang: string) => {
    if (this._init && this._lang === lang) return

    this._ready = false
    try {
      if (this._init) await i18next.changeLanguage(lang)
      else await this.initI18next(lang)
      runInAction(() => {
        this._lang = lang
        this._ready = true
      })
    } catch (e) {
      console.error('i18n error', e)
      runInAction(() => {
        this._lang = bundle_lang
        this._ready = true
      })
    }
  })

  private async initI18next(lang: string) {
    await i18next
      .use(HttpBackend)
      .use(initReactI18next)
      .init({
        ns: ['default'],
        defaultNS: 'default',
        supportedLngs: ['en', 'ru'],
        lng: lang,
        backend: { loadPath: `/api/i18n?lng={{lng}}` },
        react: { useSuspense: false },
        maxRetries: 1,
      })
  }
}

export const lang = new LanguageController()
